import segmentApi from '@edulastic/api/src/segment'
import {
  getMfaApiErrorKey,
  MFA_EMAIL_BOUNCE_ERROR_KEYS,
  MFA_GENERATION_FAILED_ERROR_KEYS,
  MFA_LIMIT_REACHED_ERROR_KEYS,
} from './mfaErrorMessages'

export const MFA_SEGMENT_ACTIONS = {
  VERIFY: 'Verify',
  RESEND: 'Resend',
  SIGNOUT: 'Signout',
  EMAIL_BOUNCE: 'EmailBounce',
  GENERATION_FAILED: 'GenerationFailed',
  LIMIT_REACHED: 'LimitReached',
  DA_GENERATED: 'DA_generated',
  SA_GENERATED: 'SA_generated',
}

export const trackSigninButtonClick = () => {
  segmentApi.genericEventTrack('Signin_ButtonClick', { Method: 'Email' })
}

export const trackMfaEvent = (mfaAction) => {
  segmentApi.genericEventTrack('MFA', { mfaActions: mfaAction })
}

const trackMfaSendFailureFromErrorKey = (errorKey) => {
  if (!errorKey) {
    return
  }
  if (MFA_EMAIL_BOUNCE_ERROR_KEYS.has(errorKey)) {
    trackMfaEvent(MFA_SEGMENT_ACTIONS.EMAIL_BOUNCE)
    return
  }
  if (MFA_LIMIT_REACHED_ERROR_KEYS.has(errorKey)) {
    trackMfaEvent(MFA_SEGMENT_ACTIONS.LIMIT_REACHED)
    return
  }
  if (MFA_GENERATION_FAILED_ERROR_KEYS.has(errorKey)) {
    trackMfaEvent(MFA_SEGMENT_ACTIONS.GENERATION_FAILED)
  }
}

export const trackMfaSendFailureFromSendError = (sendError) => {
  trackMfaSendFailureFromErrorKey(sendError)
}

export const trackMfaSendFailureFromApiError = (err) => {
  trackMfaSendFailureFromErrorKey(getMfaApiErrorKey(err))
}
